/* Client-safe facts about the Easy-Peasy.AI Browser Agent Chrome extension.
 * Shared by the Connectors modal ("My Browser" row), the /browser-extension
 * pairing page, and the connectors status API. */

/** Connector id of the "My Browser" row in /api/connectors/status. */
export const BROWSER_EXTENSION_CONNECTOR_TYPE = 'my-browser';

/** Published Chrome Web Store listing (approved 2026-09). */
export const CHROME_WEB_STORE_URL =
  'https://chromewebstore.google.com/detail/easy-peasyai-browser-agen/mkigjcomdaidhcnpggmajpbbbcdppbcf';

/** In-app pairing + device management page. */
export const BROWSER_EXTENSION_PAGE_PATH = '/browser-extension';
